import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { urler } from '../../router/router-urler';
import { useWindowScrollTop } from '../../sporsmalsflyt/hooks';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.ReiseSykdomEllerUlykkePaReisen,
        tekst: 'Sykdom, skade eller ulykke på reisen',
    },
    {
        id: KategoriSvarId.ReiseAlvorligSykdomEllerDodsfallAvbrutt,
        tekst: 'Jeg måtte avbryte reisen pga. alvorlig sykdom eller dødsfall i nær familie',
    },
];

export const ReiseSykdomUlykkeDodsfall = () => {
    const navigate = useNavigate();
    const windowScollTop = useWindowScrollTop();
    windowScollTop();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.ReiseSykdomEllerUlykkePaReisen) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.ReiseSykdomSkadeEllerUlykkePaReisen));
        } else if (svarId === KategoriSvarId.ReiseAlvorligSykdomEllerDodsfallAvbrutt) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.ReiseDodsfallEllerAlvorligSykdomPaReisen));
        }
    };

    const goback = () => navigate(urler().reiseUrl);

    return (
        <GruppeLandingsside
            title="Sykdom, ulykke eller dødsfall på reisen"
            onNext={onNext}
            navigateToParent={goback}
            alternativer={alternativer}
            svgCardType={SvgCardType.BagasjeFlyplass}
            kategoriId="reise-sykdom-ulykke-eller-dodsfall"
        />
    );
};
